// extracted by mini-css-extract-plugin
module.exports = {"levelTitle":"LevelTitle_levelTitle__DRHbQ","icon":"LevelTitle_icon__hchTH"};